import React from 'react';
import { connect } from 'react-redux';

import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { DateTimeFormat } from '../date';
import { Payment } from '../../services';


let CofirmationPayWindow = ({translate, message, invoiceNumber, invoiceId, setFlashMessage, }) => {
  return(
    <div className={`modal fade bd-example-modal-lg ${invoiceId}`} id={`${invoiceId}`} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title" >{translate('confirmation-message-title')}</h5>
            </div>
          </div>
          <div className="modal-body ">
            <h6>{translate('confirmation-message')}</h6>
          </div>
          <div className="modal-body">
            <p>{`${message}`}</p>
          </div>
          {invoiceId ?
            <div className="modal-body">
               {<p>{`${translate('invoice-id')} : ${invoiceNumber}`}</p>}
            </div>
            :
            ''
          }
          <div className="form-group row">
            <div className="col text-right">
              <button className="btn btn-secondary" type="button" data-target={`.${invoiceId}`} data-toggle="modal" >{translate('cancel')}</button>
              <button className="btn btn-primary" type="submit" data-target={`.${invoiceId}`} data-toggle="modal"
                onClick={() => {
                    Payment.invoicePayment(invoiceId)
                    .then((res) => {
                    if (res) {
                      if (res.body){
                        setFlashMessage(res.body.data.invoices, true)
                      }
                    } else {
                      setFlashMessage(translate('failed-attempt-payment'), false)
                    }
                  })

                   }} >
                   {translate('confirm')}
                 </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  }
}

CofirmationPayWindow = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(CofirmationPayWindow);
export default CofirmationPayWindow;



// WEBPACK FOOTER //
// ./src/lib/forms/CofirmationPayWindow.js